// @flow

const REGEX_DOMAIN = /.*\.(.+\..+\..+)/;

const hostnameMatch = REGEX_DOMAIN.exec(window.location.hostname);
const hostname = hostnameMatch ? hostnameMatch[1] : "localhost";

type ConfigEntry = {
    short_name: string,
    help_major_call_us_visible: boolean,
    help_major_contact_us_visible: boolean,
    help_faq_visible: boolean,
    help_contact_us_visible: boolean,
    help_contact_us_link: string,
    help_term_and_cond_link: string,
    help_apply_text: string,
    help_apply_online_trade_credit_account_link: string,
    help_store_finder_link: string,
    login_reece_personal_account: boolean,
    login_reece_personal_account_bulletpoints: string[],
    login_reece_max_account: boolean,
    login_reece_max_account_bulletpoints: string[],
    register_reece_personal_account: boolean,
    register_reece_personal_account_bulletpoints: string[],
    register_reece_max_account: boolean,
    register_reece_max_account_bulletpoints: string[]
};

type ConfigMap = {
    [key: string]: ConfigEntry
};

const DOMAIN_CONFIGS: ConfigMap = {
    localhost: {
        short_name: "LocalHost",
        help_major_call_us_visible: true,
        help_major_contact_us_visible: true,
        help_faq_visible: true,
        help_contact_us_visible: true,
        help_contact_us_link: "/localhost/contact-us",
        help_term_and_cond_link: "/localhost/term-and-cond",
        help_apply_text: "Apply online",
        help_apply_online_trade_credit_account_link: "/discovermax",
        help_store_finder_link: "/storefinder",
        login_reece_personal_account: true,
        login_reece_personal_account_bulletpoints: [
            "View your in-store quotes & shop online",
            "Design your bathroom using our <a href='/bathrooms/bathroom-planning'>3D Planner<a>",
            "Receive important information about your order"
        ],
        login_reece_max_account: true,
        login_reece_max_account_bulletpoints: [
            "Access your personalised trade rates for all products",
            "View and search your entire invoice history",
            "Place orders quickly and easily",
            "Want to learn more about how maX can work for your trade business? <a href='/discovermax'>Discover maX</a>"
        ],
        register_reece_personal_account: true,
        register_reece_personal_account_bulletpoints: [
            "View your in-store quotes &amp; shop online",
            "<a href='/bathrooms/bathroom-planning'>Design &amp; plan your bathroom</a>"
        ],
        register_reece_max_account: true,
        register_reece_max_account_bulletpoints: [
            "maX can work for your trade business",
            "<a href='/discovermax'>Find out how</a>"
        ]
    },
    "reece.co.nz": {
        short_name: "Reece",
        help_major_call_us_visible: false,
        help_major_contact_us_visible: true,
        help_faq_visible: false,
        help_contact_us_visible: false,
        help_contact_us_link: "/aboutus/contactus",
        help_term_and_cond_link: "/terms-and-conditions",
        help_apply_text: "Apply online",
        help_apply_online_trade_credit_account_link: "/discovermax",
        help_store_finder_link: "/storefinder",
        login_reece_personal_account: false,
        login_reece_personal_account_bulletpoints: [],
        login_reece_max_account: true,
        login_reece_max_account_bulletpoints: [
            "Access your personalised trade rates for all products",
            "View and search your entire invoice history",
            "Place orders quickly and easily",
            "Want to learn more about how maX can work for your trade business? <a href='/discovermax'>Discover maX</a>"
        ],
        register_reece_personal_account: false,
        register_reece_personal_account_bulletpoints: [],
        register_reece_max_account: true,
        register_reece_max_account_bulletpoints: [
            "maX can work for your trade business",
            "<a href='/discovermax'>Find out how</a>"
        ]
    },
    "reece.com.au": {
        short_name: "Reece",
        help_major_call_us_visible: true,
        help_major_contact_us_visible: false,
        help_faq_visible: true,
        help_contact_us_visible: true,
        help_contact_us_link: "/aboutus/contactus",
        help_term_and_cond_link: "/terms-and-conditions",
        help_apply_text: "Apply online",
        help_apply_online_trade_credit_account_link: "/discovermax",
        help_store_finder_link: "/storefinder",
        login_reece_personal_account: true,
        login_reece_personal_account_bulletpoints: [
            "View your in-store quotes & shop online",
            "Design your bathroom using our <a href='/bathrooms/bathroom-planning'>3D Planner<a>",
            "Receive important information about your order"
        ],
        login_reece_max_account: true,
        login_reece_max_account_bulletpoints: [
            "Access your personalised trade rates for all products",
            "View and search your entire invoice history",
            "Place orders quickly and easily",
            "Want to learn more about how maX can work for your trade business? <a href='/discovermax'>Discover maX</a>"
        ],
        register_reece_personal_account: true,
        register_reece_personal_account_bulletpoints: [
            "View your in-store quotes &amp; shop online",
            "<a href='/bathrooms/bathroom-planning'>Design &amp; plan your bathroom</a>"
        ],
        register_reece_max_account: true,
        register_reece_max_account_bulletpoints: [
            "maX can work for your trade business",
            "<a href='/discovermax'>Find out how</a>"
        ]
    },
    "actrol.com.au": {
        short_name: "Actrol",
        help_major_call_us_visible: false,
        help_major_contact_us_visible: false,
        help_faq_visible: false,
        help_contact_us_visible: true,
        help_contact_us_link: "/about-actrol/contact-us",
        help_term_and_cond_link: "/terms",
        help_apply_text: "Apply online",
        help_apply_online_trade_credit_account_link: "/discovermax",
        help_store_finder_link: "/store-finder",
        login_reece_personal_account: false,
        login_reece_personal_account_bulletpoints: [],
        login_reece_max_account: true,
        login_reece_max_account_bulletpoints: [
            "Access your personalised trade rates for all products",
            "View and search your entire invoice history",
            "Place orders quickly and easily"
        ],
        register_reece_personal_account: false,
        register_reece_personal_account_bulletpoints: [],
        register_reece_max_account: true,
        register_reece_max_account_bulletpoints: [
            "Access your personalised trade rates for all products",
            "View and search your entire invoice history",
            "Place orders quickly and easily"
        ]
    },
    "metalflex.com.au": {
        short_name: "Metalflex",
        help_major_call_us_visible: false,
        help_major_contact_us_visible: false,
        help_faq_visible: false,
        help_contact_us_visible: true,
        help_contact_us_link: "/contact-us",
        help_term_and_cond_link: "/terms-and-conditions",
        help_apply_text: "Apply online",
        help_apply_online_trade_credit_account_link: "/discovermax",
        help_store_finder_link: "/store-finder",
        login_reece_personal_account: false,
        login_reece_personal_account_bulletpoints: [],
        login_reece_max_account: true,
        login_reece_max_account_bulletpoints: [
            "Access your personalised trade rates for all products",
            "View and search your entire invoice history",
            "Place orders quickly and easily"
        ],
        register_reece_personal_account: false,
        register_reece_personal_account_bulletpoints: [],
        register_reece_max_account: true,
        register_reece_max_account_bulletpoints: [
            "Access your personalised trade rates for all products",
            "View and search your entire invoice history",
            "Place orders quickly and easily"
        ]
    }
};

export const domainConfig: ConfigEntry = DOMAIN_CONFIGS[hostname];

export const isNZ: boolean = hostname === "reece.co.nz";
export const isAU: boolean = hostname === "reece.com.au";
